function Footer() {
  return (
    <footer className="sq-footer">
      <span>
        Designed &amp; developed by{" "}
        <a href="https://nitrosolutions.co.uk/" target="_blank" rel="noopener noreferrer">
          Nitro Solutions
        </a>
      </span>
      <span>v{process.env.REACT_APP_SQADMIN_VERSION}</span>
    </footer>
  );
}

export default Footer;
